<template>
    <div>
        <el-skeleton animated :rows="showRows" :loading="loading">
            <template #default>
                <el-table :data="data" :height="460" :border="true" :stripe="true">
                    <el-table-column style="text-wrap: nowrap !important" :min-width="100" v-for="col in cols" :key="col.prop" :label="col.label" :prop="col.prop">
                    </el-table-column>
                    <slot></slot>
                </el-table>
            </template>
        </el-skeleton>
        <el-pagination class="p-2" hide-on-single-page :total="pages" :default-current-page="page" :page-count="pages" @change="change">
        </el-pagination>
    </div>
    
</template>

<script lang="ts" setup>

    type Col = {
        prop: string
        label: string
    }

    // eslint-disable-next-line no-undef
    defineProps<{
        data: unknown[]
        loading: boolean
        showRows: number
        pages: number
        page: number
        cols: Col[]
    }>()

    // eslint-disable-next-line no-undef
    const emit = defineEmits<{
        change: [page: number]
    }>()

    const change = (p: number) => {
        emit("change", p)
    }
</script>
